import { render, staticRenderFns } from "./GamesList.vue?vue&type=template&id=3161e042"
import script from "./GamesList.vue?vue&type=script&lang=js"
export * from "./GamesList.vue?vue&type=script&lang=js"
import style0 from "./GamesList.vue?vue&type=style&index=0&id=3161e042&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports